import { AllowedTo, useAbac } from "react-abac";
import { Navigate, Route, RouteProps, useNavigate } from "react-router-dom";
import { cookieNames, PAGES_URL, PARTY_ACTIVE_STATUS } from "../../shared/constants/constants";
import { getSessionVariable, getUserContext } from "../../shared/utils/utils";

interface PermissionsGateProps {
    children: React.ReactNode;
    permissions?: string[];
    isRouteElement?: boolean;
}

interface RoleBasedPermissionsGateProps {
    children: React.ReactNode;
    roles?: string[];
    isRouteElement?: boolean;
}

interface InternalAccessGateProps {
    children: React.ReactNode;
}

export function hasPermission(requiredPermissions: string[]) {
    let hasValidPermission = false;
    const UserContext: any = getUserContext();
    //console.log("UserContext : ",UserContext);
    if (UserContext && UserContext.status && UserContext.status.toUpperCase() == PARTY_ACTIVE_STATUS) {
        const userPermissions = UserContext.permissions || [];
        hasValidPermission = requiredPermissions.some(permission => userPermissions.includes(permission));
    }
    return hasValidPermission;
};

function hasRequiredRole(requiredRoles: string[]) {
    // console.log(requiredRoles)
    let hasValidRole = false;
    const UserContext: any = getUserContext();
    //console.log("UserContext : ",UserContext);
    if (UserContext && UserContext.status && UserContext.status.toUpperCase() === PARTY_ACTIVE_STATUS) {
        const userOrgPartyRole = UserContext.orgPartyRole || "";
        // console.log(userOrgPartyRole)
        if (requiredRoles.includes(userOrgPartyRole)) {
            hasValidRole = true;
        }
    }
    return hasValidRole;
};
function hasPartyRequiredRole(requiredRoles: string[]) {
    // console.log(requiredRoles)
    let hasValidRole = false;
    const UserContext: any = getUserContext();
    
    if (UserContext && UserContext.status && UserContext.status.toUpperCase() === PARTY_ACTIVE_STATUS) {
        const PartyRole = UserContext.roles || "";
        let item: any;
        for (item of requiredRoles) {
            if (PartyRole.includes(item)) {
                hasValidRole = true;
                break;
            }
        }
    }
    return hasValidRole;
};

export default function PermissionsGate({ children, permissions = [], isRouteElement = false }: PermissionsGateProps) {
    const navigate = useNavigate();
    const permissionGranted = hasPermission(permissions);
    if (!permissionGranted) {
        if (isRouteElement) {
            navigate(PAGES_URL.DASHBOARD); // Redirect to login page
            return null;
        }
        else {
            return <></>
        }
    }
    return <>{children}</>;
};

export function RoleBasedPermissionsGate({ children, roles = [], isRouteElement = false }: RoleBasedPermissionsGateProps) {
    const navigate = useNavigate();
    const permissionGranted = hasRequiredRole(roles);
    if (!permissionGranted) {
        if (isRouteElement) {
            navigate(PAGES_URL.DASHBOARD); // Redirect to login page
            return null;
        }
        else {
            return <></>
        }
    }
    return <>{children}</>;
};
export function PartyRoleBasedPermissionsGate({ children, roles = [], isRouteElement = false }: RoleBasedPermissionsGateProps) {
    const navigate = useNavigate();
    const permissionGranted = hasPartyRequiredRole(roles);
    if (!permissionGranted) {
        if (isRouteElement) {
            navigate(PAGES_URL.DASHBOARD); // Redirect to login page
            return null;
        }
        else {
            return <></>
        }
    }
    return <>{children}</>;
};

export function InternalAccessGate({children}: InternalAccessGateProps){
    const userDetails = getSessionVariable(cookieNames.prismUser);
    if(userDetails) {
        const parsedUserDetails = JSON.parse(userDetails);
        if(JSON.parse(process.env.REACT_APP_INTERNAL_PARTIES || "[]").includes(parsedUserDetails.orgPartyIds[0])){
            return <>{children}</>;
        }
    }
    return <></>
}